import { render, staticRenderFns } from "./matrix10num.vue?vue&type=template&id=0dc27ad0"
import script from "./matrix10num.vue?vue&type=script&lang=js"
export * from "./matrix10num.vue?vue&type=script&lang=js"
import style0 from "./matrix10num.vue?vue&type=style&index=0&id=0dc27ad0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports